module.exports = __webpack_public_path__ + "static/vegas13-2-5bacef606ce408e39fd4138b280d0d60.jpg";